import { withDependencies } from '@wix/thunderbolt-ioc'
import type {
	BrowserWindow,
	Experiments,
	IAppDidMountHandler,
	IAppWillUnmountHandler,
	ViewerModel,
} from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol, ExperimentsSymbol, ViewerModelSym } from '@wix/thunderbolt-symbols'
import { isSSR } from '@wix/thunderbolt-commons'
import { isExperimentOpen } from '@wix/thunderbolt-experiments'
import { OnLinkClickSymbol } from './symbols'
import { PREVENT_ANCHOR_RELOAD_SPEC } from './preHydrationAnchorGuard'
import type { IOnLinkClickHandler } from './types'
import React from 'react'

export const clickHandlerRegistrarFactory = (
	browserWindow: NonNullable<BrowserWindow>,
	{ onLinkClick }: IOnLinkClickHandler,
	viewerModel: ViewerModel,
	experiments: Experiments
): IAppDidMountHandler & IAppWillUnmountHandler => {
	return {
		appDidMount: () => {
			if (isSSR(browserWindow)) {
				return
			}
			browserWindow.addEventListener('click', onLinkClick)
			// `onLinkClick` now owns anchor clicks — hand off from the pre-hydration guard (TB-14458).
			// The guard is registered on `document` in capture phase, so it must be removed from
			// `document` with the same capture flag (removing from `window` is a no-op and leaks it).
			if (isExperimentOpen(experiments, PREVENT_ANCHOR_RELOAD_SPEC) && browserWindow.__tbAnchorGuard) {
				browserWindow.document.removeEventListener('click', browserWindow.__tbAnchorGuard, true)
				browserWindow.__tbAnchorGuard = undefined
			}
			if (viewerModel.mode.debug && React.version.startsWith('18')) {
				// for some reason react 18 strict mode doesn't fire click events on window
				Array.from(document.querySelectorAll?.('a') || []).map((e) => e.addEventListener('click', onLinkClick))
			}
		},
		appWillUnmount: () => {
			browserWindow.removeEventListener('click', onLinkClick)
		},
	}
}

export const ClickHandlerRegistrar = withDependencies(
	[BrowserWindowSymbol, OnLinkClickSymbol, ViewerModelSym, ExperimentsSymbol],
	clickHandlerRegistrarFactory
)
